import { EventEmitter } from 'event-emitter';
import screenObserver from './display-handlers';

export class DisplayListener extends EventEmitter {
	current = screenObserver.peek();

	constructor () {
		super(...arguments);

		this.setSubscribes();
	}

	setSubscribes () {
		screenObserver.subscribe(this.handleChangeSize);
	}

	handleChangeSize = value => {
		this.current = value;
		this.emit('screen-changes', {value});
	}
}


export const displayListener = new DisplayListener();
